(() => {
  if (window.capriProductDetailsInitialized) return;
  window.capriProductDetailsInitialized = true;
  const colors = {white:'#ffffff',black:'#191919',wood:'#c6a47a',pink:'#efc3d2',blue:'#b8dbe9',burgundy:'#3d1124'};
  const previewPrices = new WeakMap();
  function updatePricePreview(section, variant) {
    const preview = section.querySelector('[data-capri-preview-price]');
    if (!preview || window.Shopify?.theme?.role !== 'development' || variant === undefined) return;
    if (!previewPrices.has(preview)) {
      try {
        previewPrices.set(preview, JSON.parse(preview.querySelector('[data-capri-preview-prices]').textContent));
      } catch (_) { return; }
    }
    const prices = variant && previewPrices.get(preview)[variant.id];
    preview.hidden = !prices;
    section.classList.toggle('capri-price-preview-enabled', Boolean(prices));
    if (!prices) return;
    preview.querySelector('[data-capri-preview-original]').innerHTML = prices.original;
    preview.querySelector('[data-capri-preview-sale]').innerHTML = prices.sale;
  }
  function update(section, variant) {
    updatePricePreview(section, variant);
    const badge = section.querySelector('[data-capri-discount]');
    if (badge && variant !== undefined) {
      const onSale = variant && variant.compare_at_price > variant.price;
      badge.hidden = !onSale;
      badge.textContent = onSale ? `${Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100)}% OFF` : '';
    }
    section.querySelectorAll('[data-capri-option]').forEach(group => {
      const selected = group.querySelector('input:checked');
      const legend = group.querySelector('[data-capri-option-value]');
      if (legend && selected) legend.textContent = selected.value;
      if (!['color','ribbon-color'].includes(group.dataset.capriOption)) return;
      group.querySelectorAll('.radio__button').forEach(button => {
        const input = button.querySelector('input');
        const label = button.querySelector('label');
        const color = input && colors[input.value.toLowerCase()];
        if (!color || !label) return;
        button.classList.add('capri-color-option');
        label.style.setProperty('--capri-option-color',color);
        label.title = input.value;
      });
    });
  }
  function init(root) {
    root.querySelectorAll('[data-section-type="product-template"]').forEach(section => {
      const json = section.querySelector('[data-product-json]');
      let variant;
      if (json) {
        try {
          const product = JSON.parse(json.textContent);
          const id = section.querySelector('[name="id"]')?.value;
          variant = product.variants.find(v => String(v.id) === id) || product.variants[0];
        } catch (_) { /* Native product events will provide the selected variant. */ }
      }
      update(section,variant);
    });
  }
  document.addEventListener('theme:variant:change', event => {
    const section = event.target.closest('[data-section-type="product-template"]');
    if (section) update(section,event.detail.variant);
  });
  document.addEventListener('change',event => {
    const section = event.target.closest('[data-section-type="product-template"]');
    if (section) update(section,undefined);
  });
  document.addEventListener('shopify:section:load', () => init(document));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
})();
